import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getPlantWarehouses } from "../../../../services/production/productionService";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";

function SearchPlantWarehouse({ plantID = 0, onSelectWarehouse }) {
  const [warehouses, setWarehouses] = useState([]);
  const getPlantWarehouseData = async (plantID) => {
    const response = await getPlantWarehouses(plantID);
    const { data } = response.data;
    setWarehouses(data.warehouses);
  };
  useEffect(() => {
    getPlantWarehouseData(plantID);
  }, [plantID]);
  return (
    <React.Fragment>
      <CustomDataTableSearch
        data={warehouses}
        onRefreshData={() => {
          getPlantWarehouseData();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectWarehouse(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectWarehouse(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Warehouse ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Warehouse",
            field: "warehouseName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.warehouseName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Phone Number",
            field: "addressPhone",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.addressPhone} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "City",
            field: "city",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.city} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    </React.Fragment>
  );
}

export default SearchPlantWarehouse;
